<!-- src/views/HomePage.vue -->
<template>
  <div class="c-text-column" style="    position: relative;top: -90px;">
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-5">FRANKA ROBOTICS</span>
      
        <div class="c-text-align">
          <h1 style="font-size: 40px;font-family: 'Montserrat', sans-serif;text-align: left;">Franka Hand</h1>
        </div>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          Franka Hand 是一款由 Franka Robotics 设计并制造的两指平行夹爪，旨在与 Franka 机器人无缝配合。该夹爪专为高精度和直观易用性而设计，能够轻松实现研究、制造和实验室应用中的自动化。
        </span>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          无需外部线缆或单独的控制器。Franka Hand 原生集成于 Franka 平台，通过机器人法兰接口直接连接，该接口同时提供电源和数据通信，使安装快速且可靠。
        </span>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          借助这种快速启动设计，用户几乎可以立即开始操作系统，从而最大限度地减少设置时间并提高生产力。
        </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <router-link to="/contact" class="buttonSite  c-mr-20">立刻联系</router-link>
        </div>
      </div>

      <div class="display-width c-text-align">
        <div style="aspect-ratio:  716/450;">
          <img src="@/assets/images/productsPage/Franka Hand.png"  style="width: 100%;aspect-ratio: 716/450;" />
        </div>
      </div>
    </div>
    <div>
      <div class="line-with-text px-container ">
        <hr class="divider">
        <span class="line-text">产品详情
        </span>
        <hr class="divider">
      </div>
       <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px; ">
        <div class="display-width c-text-column c-mb-60  c-pdr-40"
          style="align-items: flex-start; justify-content: center;">
          <h3>技术规格与详情</h3>
          <strong>主要特点</strong>
          <li class="c-mt-10 c-ml-20"><strong>完全集成:</strong>
            通过法兰接口由机器人直接供电和控制，无需外部控制器、驱动器或线缆。
          </li>
          <li class="c-mt-10 c-ml-20"><strong>两指平行夹爪:</strong>
            非常适合抓取各种物体。
          </li>
          <li class="c-mt-10 c-ml-20"><strong>自适应指尖:</strong>
            指尖可轻松更换，并根据待抓取物体进行调整（例如使用 3D 打印的指尖）。
          </li>
          <li class="c-mt-10 c-ml-20"><strong>快速安装:</strong>
            使用随附的螺钉直接安装到法兰上，并可通过 Desk 立即激活。
          </li>
            <strong class="c-mt-20">机械规格</strong>
          <li class="c-mt-10 c-ml-20"><strong>外形尺寸:</strong>
          </li>
          <div class="c-mt-10 c-ml-20">宽度：63 mm</div>
          <div class="c-mt-10 c-ml-20">长度：205 mm</div>
          <div class="c-mt-10 c-ml-20">高度：127 mm</div>
          <li class="c-mt-10 c-ml-20"><strong>重量:</strong>730 g
          </li>
           <div class="c-mt-10">Franka Hand 的接口/法兰依据 DIN ISO 9409-1-A50 标准设计。<a href="https://franka.de/hubfs/Franka%20Hand_Flange.png?hsLang=en" class="linkTag" target="_blank">
            参见图示</a></div>
           <a  @click="$router.push('/documents#franka-hand')" class="linkTag" target="_blank">
            下载产品手册</a>
        </div>
        <div class="display-width c-text-both" style="aspect-ratio: 716/450;">
          <div class="carousel-container">
            <div class="carousel" @mouseenter="pauseCarousel" @mouseleave="resumeCarousel">
              <div class="slides-wrapper" :style="{ transform: `translateX(-${activeIndex * 100}%)` }">
                <div v-for="(img, index) in images" :key="index" class="slide">
                  <img :src="img.src" :alt="img.alt" class="carousel-img">
                </div>
              </div>

              <button class="carousel-btn prev" @click="prevSlide">
                <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 15L2 8L10 1" stroke="white" stroke-width="2"></path>
                </svg>
              </button>
              <button class="carousel-btn next" @click="nextSlide">
                <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 15L9 8L1 1" stroke="white" stroke-width="2"></path>
                </svg>
              </button>

              <div class="carousel-indicators">
                <span v-for="(img, index) in images" :key="'indicator-' + index"
                  :class="{ active: activeIndex === index }" @click="goToSlide(index)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">须知事项</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">兼容性</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          Franka Hand 兼容 Franka Robotics 的所有机器人。通过 Desk 操作时，可使用随机器人免费提供的专用 App 进行启用，开箱即可快速、轻松地启动。
        </span>
      </div>
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">所需知识</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         对机器人设置、Desk 以及安全硬件安装有基本的了解。
        </span>
      </div>
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">安装方法</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         使用随附的螺钉将 Franka Hand 固定到法兰上，将集成的电源与数据线缆连接到法兰上的末端执行器接口，然后通过 Franka Desk 界面激活。几分钟内，您的机器人即可准备就绪，执行精确的抓取和操作任务。
        </span>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
        更多信息请参阅
        <a  @click="$router.push('/documents#franka-hand')" class="linkTag" target="_blank">
            快速指南</a>
        </span>
      </div>
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">应用场景</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          Franka Hand 专为多种自动化场景而设计，包括：
        </span>
        <li class="c-mt-10 c-ml-20 text-left">
         拾取与放置操作
        </li>
        <li class="c-mt-10 c-ml-20 text-left">
          精密装配任务
        </li>
        <li class="c-mt-10 c-ml-20 text-left">
          实验室样品处理
        </li>
        <li class="c-mt-10 c-ml-20 text-left">
         包装与分拣
        </li>
        <li class="c-mt-10 c-ml-20 text-left">
         研究与教育
        </li>
        <div class="c-mt-10 c-ml-20 text-left">其自适应指尖使其非常适合处理各种形状、材质和尺寸的物体。</div >
      </div>
    </div>
     <div class="line-with-text px-container">
        <hr class="divider">
        <span class="line-text">组件</span>
        <hr class="divider">
      </div> 
      <div class="c-text-between px-container c-flex-wrap">
        <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
          <h1>探索第三方配件</h1>
        
          <div class="c-text-justify-start c-flex-wrap c-mt-20 c-mb-10"> 
            <div class="buttonSite">
              <!-- documents -->
              <!-- <a href="/#/resources" target="_blank">获取资料</a> -->
              <a  @click="$router.push('/accessories')"  target="_self">获取更多</a>
            </div>
          </div>  
        </div>
        <div class="display-width">
          <img src="@/assets/images/productsPage/Murrplastik_01 (1).jpg" alt=""
            style="    height: auto; max-width: 100%;">
        </div>
      </div>

  </div>
</template>

<script>

import backgroundImage from "@/assets/images/productsPage/FR3 move new 6.png";
export default {
  metaInfo() {
    return {
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },
  name: 'HomePage',
  data() {
    return {
      activeIndex: 0,
      carouselInterval: null,
      isTransitioning: false,
      images: [
        { src: require('@/assets/images/productsPage/_Frank Robotics0304 1_resized (1).jpg'), alt: 'Franka Robotics产品图片1' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0363_RESIZED.jpg'), alt: 'Franka Robotics产品图片2' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0443_RESIZED.jpg'), alt: 'Franka Robotics产品图片3' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0464_RESIZED.jpg'), alt: 'Franka Robotics产品图片4' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0570_RESIZED.jpg'), alt: 'Franka Robotics产品图片5' },
      ],
      iframe1: '2',
      iframe2: '2',
      backgroundImage: backgroundImage,
      tableData: [
        { name: '基于工作流的应用程序编程', DESK: true, RIDE: false, FCI: false },
        { name: '快速原型设计实验和演示 ', DESK: true, RIDE: false, FCI: false },
        { name: '执行机器人任务', DESK: true, RIDE: false, FCI: true },
        { name: '开发自定义应用程序', DESK: false, RIDE: true, FCI: false },
        { name: '连接第三方硬件', DESK: false, RIDE: true, FCI: true },
        { name: '连接外部资源', DESK: false, RIDE: true, FCI: true },
        { name: '1 kHz 力矩、位置和速度控制 ', DESK: false, RIDE: false, FCI: true },
        { name: '1 kHz 传感器信号和机器人状态的测量', DESK: false, RIDE: false, FCI: true },
        { name: '访问机器人运动学和动力学模型', DESK: false, RIDE: false, FCI: true },
        { name: '与ROS和MATLAB & Simulink的集成', DESK: false, RIDE: false, FCI: true },
      ]
    }

  },
  mounted() {
    this.startCarousel();
  },
  beforeUnmount() {
    clearInterval(this.carouselInterval);
  },
  methods: {
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex + 1) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500); // 与过渡时间保持一致
    },
    prevSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    goToSlide(index) {
      if (this.isTransitioning || index === this.activeIndex) return;
      this.isTransitioning = true;

      this.activeIndex = index;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    pauseCarousel() {
      clearInterval(this.carouselInterval);
    },
    resumeCarousel() {
      this.startCarousel();
    }
  }
};
</script>
<style scoped>
.newBack:hover {
  background-color: #1b2f36;
  color: white;
}

.desktop-image {
  display: block;
  width: 100%;
}

.mobile-image {
  display: none;
  width: 100%;
}

@media (max-width: 999px) {
  .desktop-image {
    display: none;
  }
  .mobile-image {
    display: block;
  }
}

/* 新增轮播图样式 - 水平滑动效果 */
.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.slides-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
  will-change: transform;
}

.slide {
  flex: 0 0 100%;
  min-width: 100%;
  position: relative;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.carousel-btn:hover {
  /* background: rgba(0,0,0,0.8); */
}

.carousel-btn.prev {
  left: 15px;
}

.carousel-btn.next {
  right: 15px;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.carousel-indicators span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background 0.3s ease;
}

.carousel-indicators span.active {
  background: white;
}

li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}

.flex-width {
  width: calc(100% / 6);
}

@media (max-width: 1260px) {
  .flex-width {
    width: calc(100% / 4);
  }
}

@media (max-width: 999px) {
  .flex-width {
    width: calc(100% / 3);
  }
}

@media (max-width: 747px) {
  .flex-width {
    width: calc(100% / 2);
  }
}

@media (max-width: 150px) {
  .flex-width {
    width: 100%
  }
}

.title-width {
  width: 33.33%;
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .title-width {
    width: 100%
  }
}

.action-height {
  height: 400px;
  background-color: #d5dbdc;
  position: relative;
}

.action-width {
  width: calc(33% - 40px);
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .action-width {
    width: calc(50% - 40px);
  }

  .action-height {
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .action-width {
    width: 100%;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 5px;
  text-align: left;
}
</style>